import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-被征地农民养老保险-列表
 */
export function API_PENSION_INSURANCE_LIST(data?: BasicPageReq) {
  return http.post<ApiPensionInsurance.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-被征地农民养老保险-全部
 */
export function API_PENSION_INSURANCE_ALL(data?: BasicPageReq) {
  return http.post<ApiPensionInsurance.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-被征地农民养老保险-详情
 */
export function API_PENSION_INSURANCE_DETAIL(id: string) {
  return http.post<ApiPensionInsurance.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-被征地农民养老保险-新增
 */
export function API_PENSION_INSURANCE_ADD(data: ApiPensionInsurance.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-被征地农民养老保险-删除
 */
export function API_PENSION_INSURANCE_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-被征地农民养老保险-编辑
 */
export function API_PENSION_INSURANCE_EDIT(data: BasicUpdateOneReq<ApiPensionInsurance.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-被征地农民养老保险-禁用
 */
export function API_PENSION_INSURANCE_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-被征地农民养老保险-启用
 */
export function API_PENSION_INSURANCE_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-被征地农民养老保险-排序
 */
export function API_PENSION_INSURANCE_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-被征地农民养老保险-审核列表
 */
export function API_PENSION_INSURANCE_REVIEW_LIST(data?: BasicPageReq) {
  return http.post<ApiPensionInsurance.ListRes>(URL.REVIEW_LIST, data)
}

/**
 * 集体土地项目-被征地农民养老保险-参保人员名单预览
 */
export function API_PENSION_INSURANCE_SECURITY_FILES_PREVIEW(data: ApiPensionInsurance.SecurityFilesPreviewReq) {
  return http.post<Record<string, any>[]>(URL.SECURITY_FILES_PREVIEW, data)
}
